import {
    Guid
} from './guid'
const Http = function (tokenKey) {
    this.tokenKey = tokenKey
    let DeviceID = localStorage.DeviceID
    if (!DeviceID) {
        DeviceID = Guid.NewGuid().ToString('D')
        localStorage.DeviceID = DeviceID
    }
    this.DeviceID = DeviceID
}

Http.prototype.fetch = function (url, method, params = {}, fetchConfig = {}, token) {
    url = process.env.VUR_APP_BASE_URL + url
    fetchConfig.showLoading = fetchConfig.showLoading === undefined ? true : fetchConfig.showLoading
    if (this.beforeRequest) {
        this.beforeRequest(fetchConfig)
    }
    let config = {
        method: method,
        mode: 'cors'
    };
    config.headers = {
        // DeviceType: 'PC',
        // DeviceID: this.DeviceID,
    };
    
    if (params instanceof FormData) {
        config.body = params
    } else {
        if (method == 'get' || method == 'head') {
            if (url.indexOf('?') > 0) {
                url += '&'
            } else {
                url += '?'
            }
            for (let key in params) {
                let value = params[key]
                if (typeof (value) == 'function' || value === undefined) {
                    continue
                }
                url += key + '=' + encodeURIComponent(value) + '&';
            }
        } else {
            let obj = {};
            for (let key in params) {
                let value = params[key];
                if (typeof (value) == 'function' || value === undefined) {
                    continue;
                }
                obj[key] = value;
            }
            config.body = JSON.stringify(obj);
        }
        config.headers['Content-Type'] = 'application/json';
    }

    if (localStorage[this.tokenKey] || token) {
        config.headers.Authorization = 'Bearer ' + (localStorage[this.tokenKey] ? localStorage[this.tokenKey] : token);
    }
    return new Promise((resolve, reject) => {
        fetch(url, config).then(async res => {
            if (this.afterRequest) {
                this.afterRequest();
            }
            if (res.status == 200) {
                let data = await res.json();
                if (data.code == 200) {
                    resolve(data.data || data);
                } else if (data.code == 203) {
                    resolve(data);
                } else {
                    if (fetchConfig.onError) {
                        fetchConfig.onError(data);
                    } else if (this.onApiError) {
                        this.onApiError(data);
                        // reject(data);
                        if (fetchConfig.retError) {
                            resolve(null);
                        }
                    }
                    reject(data);
                }
            } else {
                reject(res.statusText);
            }
        });
    });
};
function buildHttpConfig(isAuthRequest) {
    let config
    if (typeof isAuthRequest == 'boolean') {
        config = {
            isAuthRequest
        }
    } else {
        config = isAuthRequest
    }
    if (config.showLoading === undefined) {
        config.showLoading = true
    }
    return config
}

Http.prototype.get = function (url, params, isAuthRequest = false, token) {
    return this.fetch(url, 'get', params, buildHttpConfig(isAuthRequest), token)
}

Http.prototype.post = function (url, params, isAuthRequest = false, token) {
    return this.fetch(url, 'post', params, buildHttpConfig(isAuthRequest), token)
}

Http.prototype.put = function (url, params, isAuthRequest = false) {
    return this.fetch(url, 'put', params, buildHttpConfig(isAuthRequest))
}

Http.prototype.delete = function (url, params, isAuthRequest = false) {
    return this.fetch(url, 'delete', params, buildHttpConfig(isAuthRequest))
}

export default {
    build: tokenKey => {
        return new Http(tokenKey)
    }
}


// WEBPACK FOOTER //
// ./src/utils/http.js